// src/checkbox/checkbox-checked-context.ts
import { createContext } from "react";
var CheckboxCheckedContext = createContext(false);
export { CheckboxCheckedContext };